import React from "react";
import { VehicleDetailsContextProvider } from "./VehicleDetailsView";
import VehicleDetails from "./view/VehicleDetails";
import Content from "../../constants/contentFile.json"

const VehicleDetailsPage = () => {
  return (
    <VehicleDetailsContextProvider>
        <VehicleDetails textContent={Content.employeeVehicleDetails}/>
    </VehicleDetailsContextProvider>
  );
};

export default VehicleDetailsPage;
